import { useRef } from 'react';
import Icon from '../icon';
import { PRINT_STATUS_CLOSE_BUTTON_ID } from '../../constants';
import getPdfViewerApplication from '../../utils/pdfjs/pdfViewerApplication';

export default function PrintProgress() {
  const buttonRef = useRef();
  return (
    <div className="print-progress-container">
      <Icon.Spinner className="print-progress-spinner" width={28} height={28} />
      <span className="print-progress-message">Preparing document for printing...</span>
      <button
        className="close-button"
        title="Cancel print"
        type="button"
        onClick={() => getPdfViewerApplication().cancelPrint()}
        id={PRINT_STATUS_CLOSE_BUTTON_ID}
        ref={buttonRef}
        onMouseLeave={() => buttonRef.current.blur()}
      >
        <Icon.Cross />
      </button>
    </div>
  );
}
